import { render, staticRenderFns } from "./DashboardSynthetic.vue?vue&type=template&id=d5065502&scoped=true"
import script from "./DashboardSynthetic.vue?vue&type=script&lang=js"
export * from "./DashboardSynthetic.vue?vue&type=script&lang=js"
import style0 from "./DashboardSynthetic.vue?vue&type=style&index=0&id=d5065502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5065502",
  null
  
)

export default component.exports